<template>
    <v-row v-if="!['admin', 'editor'].includes(currentPermission.privilegeLevel)"
        align="center"
        justify="center"
    >
        <v-col
        cols="12"
        sm="8"
        md="5"
        >
            <AccessDeniedCard/>
        </v-col>
    </v-row>
    <v-row
        v-else
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="11"
         
        >
            <v-tabs-items class="transparent" v-model="onboardTab" align-center justify-center>
                <!-- Tab Item 0 -->
                <v-tab-item class="default-background-color">
                    <v-card class="pa-0 ma-0 default-background-color" flat>
                        <v-card-title>
                            {{ pageTitle[this.businessCardEditorTab] }}
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <BusinessCardEditor :isOnBoarding="true" :tab="businessCardEditorTab" :bus="bus" ref="cardEditor" />
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text width="150" v-if="businessCardEditorTab == 0" @click="$router.go(-1)" color="primary" depressed large class="text-body-1">Back</v-btn>
                            <v-btn text width="150" v-if="businessCardEditorTab > 0" @click="onBack" color="primary" depressed large class="text-body-1">Back</v-btn>
                            <v-spacer/>
                            <v-btn width="150" to="/" text color="primary" large class="text-body-1">Skip for now</v-btn>
                            <v-btn width="150" @click="onNext" color="primary" large depressed class="text-body-1">Next</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
                <!-- Tab Item 1 -->
                <v-tab-item eager class="default-background-color">
                    <v-row
                        align="center"
                        justify="center"
                    >
                        <v-col
                        cols="12"
                        sm="8"
                        md="5"
                        >
                            <v-card outlined>
                                <v-card-title>Let’s add some Contact Details for your Business</v-card-title>
                                <v-card-subtitle>Add the important details and social media accounts for your business. Details that need to be specific for each team member can be customised accordingly.</v-card-subtitle>
                                <v-card-text>
                                    <!-- <v-img src="https://www.manlyhotel.com/wp-content/uploads/2016/08/placeholder-e1470833356610.jpg" max-height="250"></v-img> -->
                                    <v-row align="center" justify="center">
                                        <v-col cols="12">
                                            <lottie-animation path="business-card-preview-on-device.json"/>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions class="px-4 pb-3 pt-0">
                                    <v-row no-gutters>
                                        <v-col cols=12>
                                            <v-btn @click="onNext" block color="primary" large depressed class="text-body-1">Add Contact Details</v-btn>
                                        </v-col>
                                        <v-col cols=12>
                                            <v-btn text elevation="0" @click="onBack" block  color="primary" large class="mt-3 text-body-1">Back</v-btn>
                                        </v-col>
                                        <v-col cols=12>
                                            <v-btn block to="/" text color="primary" large class="mt-3 text-body-1">Skip for now</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        </v-row>
                </v-tab-item>
                <!-- Tab Item 2 -->
                <v-tab-item :eager="true" class="default-background-color">
                    <v-row
                        align="center"
                        justify="center"
                    >
                        <v-col
                        cols="12"
                        sm="8"
                        md="5"
                        >
                            <v-card outlined>
                                <v-card-title>Add your organization's details</v-card-title>
                                <v-card-subtitle>These details accompany each of your team member's business cards.</v-card-subtitle>
                                <v-card-text>
                                    <BusinessDetailsEditor :bus="bus" ref="businessDetailsEditor" />
                                </v-card-text>
                                <v-card-actions class="pb-3 pt-0 mt-n5">
                                    <v-row no-gutters>
                                        <v-col cols=12>
                                            <v-btn @click="onNext" block color="primary" large depressed class="text-body-1">Save</v-btn>
                                        </v-col>
                                        <v-col cols=12>
                                            <v-btn text elevation="0" @click="onBack" block  color="primary" large class="mt-3 text-body-1">Back</v-btn>
                                        </v-col>
                                        <!-- <v-col cols=12>
                                            <v-btn block to="/" text color="primary" large class="mt-3 text-body-1">Skip for now</v-btn>
                                        </v-col> -->
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <!-- Tab Item 3 -->
                <v-tab-item eager class="default-background-color">
                        <v-row
                        align="center"
                        justify="center"
                    >
                        <v-col
                        cols="12"
                        sm="8"
                        md="5"
                        >
                            <v-card outlined>
                                <v-card-title>You're now ready to start adding team members</v-card-title>
                                <v-card-subtitle>Start adding profiles and inviting your team members to download the Pappyon app to their devices.</v-card-subtitle>
                                <v-card-text>
                                    <v-row align="center" justify="center">
                                        <v-col cols="12">
                                            <lottie-animation path="business-card-exchange-preview.json"/>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions class="px-4 pb-3">
                                    <v-row no-gutters>
                                        <v-col cols=12>
                                            <!-- <v-btn to="/onboardCardholders" block color="primary" depressed large class="text-body-1">Add Team Members</v-btn> -->
                                             <v-btn to="/cardholders" block color="primary" depressed large class="text-body-1">Add Team Members</v-btn>
                                        </v-col>
                                        <v-col cols=12>
                                            <v-btn text elevation="0" @click="onBack" block  color="primary" large class="mt-3 text-body-1">Back</v-btn>
                                        </v-col>
                                        <v-col cols=12>
                                            <v-btn to="/" block text color="primary" large class="mt-3 text-body-1">Skip for now</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        </v-row>
                </v-tab-item>
        </v-tabs-items>
              
        </v-col>
   </v-row>
</template>
<script>
import BusinessCardEditor from '@/components/BusinessCardEditor'
import BusinessDetailsEditor from '@/components/BusinessDetailsEditor'
import Vue from 'vue'
import BusinessCardRotator from '@/components/BusinessCardRotator'
import AccessDeniedCard from '@/components/AccessDeniedCard'
import { mapGetters, mapActions } from 'vuex'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs

export default {
    name: 'Onboard',
    data() {
        return {
            onboardTab: 0,
            businessCardEditorTab: 0,
            bus: new Vue(),
            pageTitle: [
                'Start by customizing the front of your Business Card',
                'Next, customize the back of your Business Card',
                'Lastly, add a background wallpaper'
            ]
        }
    },
    computed: mapGetters(['currentPermission', 'businessProfile']),
    created() {
        let tabIndex = parseInt(this.$route.params.tabIndex);
        if (tabIndex >=0 && tabIndex<=3) {
            this.onboardTab = tabIndex;
        } else {
            this.onboardTab = 0;
        }
    },
    components: {
        BusinessCardEditor,
        BusinessDetailsEditor,
        BusinessCardRotator,
        AccessDeniedCard,
        LottieAnimation,
    },
    watch: {
        $route(to, from) {
            // react to route changes...
            let tabIndex = parseInt(to.params.tabIndex);
            if (this.onboardTab != tabIndex)
                this.onboardTab = tabIndex;
        }
    },
    methods: {
        ...mapActions(['updateBusinessProfileDetails']),
        async onNext() {
            if (this.onboardTab == 0) {
                await this.$refs.cardEditor.onSave();
                if (this.businessCardEditorTab == 2) {
                    //Start: Update isBusinessCardDesignAdded if required
                    if (this.businessProfile.isBusinessCardDesignAdded != true) {
                        this.updateBusinessProfileDetails({
                        isBusinessCardDesignAdded: true,
                        });
                    }
                    //End: Update isBusinessCardDesignAdded if required
                    this.onboardTab ++;
                }
                else
                    this.businessCardEditorTab ++;
            } else if (this.onboardTab == 1) {
                this.onboardTab ++;
            } else if (this.onboardTab == 2) {
                let isValid = await this.$refs.businessDetailsEditor.onSave();
                if (isValid) {
                    //Start: Update isBusinessCardInformationAdded if required
                    if (this.businessProfile.isBusinessCardInformationAdded != true) {
                        this.updateBusinessProfileDetails({
                            isBusinessCardInformationAdded: true,
                        });
                    }
                    //End: Update isBusinessCardInformationAdded if required
                    this.onboardTab ++;
                }
            } else if (this.onboardTab == 3) {
                this.onboardTab ++;
            }
            if (this.onboardTab != 0)
                this.$router.push({ params: { tabIndex: this.onboardTab } });
        },
        onBack() {
            if (this.onboardTab > 0) {
                this.onboardTab--;
                this.$router.go(-1);
            }
            else
                this.businessCardEditorTab--;
        },
    }
}
</script>
<style scoped>
.default-background-color {
      background-color: #F6F6F6 !important;
}
</style>